import { Grid, Typography } from '@mui/material';
import { UserAccountDto } from '../../../services/dtos/user-account.dto';
import React from 'react';
import './account.ui.scss';
import Button from '@mui/material/Button';
import ReportChangeDialogForm from '../../forms/reportChange/reportChangeDialog.form';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';

/**
 * Ui pour les pages admins
 * @constructor
 */
export default function AccountUi(
    props: Readonly<{
        open: boolean;
        handleClickOpen: () => void;
        handleClose: () => void;
        handleSuccess: () => void;
        data: UserAccountDto;
    }>
) {
    const formatBirthDate = (birthDate?: string): string => {
        if (!birthDate) {
            return 'Non renseignée';
        }

        const parts = birthDate.split('-');

        if (parts.length !== 3) {
            return birthDate;
        }

        return [parts[2], parts[1], parts[0]].join('/');
    };

    const getValue = (value?: string): string => {
        if (!value) {
            return 'Non renseigné';
        }

        return value;
    };

    const getInitials = (): string => {
        const firstInitial = props.data.firstName?.trim().charAt(0) ?? '';
        const lastInitial = props.data.lastName?.trim().charAt(0) ?? '';
        const initials = `${firstInitial}${lastInitial}`.trim().toUpperCase();

        return initials || 'E';
    };

    const details = [
        {
            icon: <HomeOutlinedIcon fontSize="small" />,
            label: 'Adresse postale',
            value: getValue(props.data.address),
        },
        {
            icon: <AlternateEmailOutlinedIcon fontSize="small" />,
            label: 'Adresse e-mail',
            value: getValue(props.data.email),
        },
        {
            icon: <AlternateEmailOutlinedIcon fontSize="small" />,
            label: 'Adresse e-mail secondaire',
            value: getValue(props.data.secondaryEmail),
        },
        {
            icon: <CakeOutlinedIcon fontSize="small" />,
            label: 'Date de naissance',
            value: formatBirthDate(props.data.birthDate),
        },
        {
            icon: <LocalPhoneOutlinedIcon fontSize="small" />,
            label: 'Téléphone fixe',
            value: getValue(props.data.landphone),
        },
        {
            icon: <SmartphoneOutlinedIcon fontSize="small" />,
            label: 'Téléphone portable',
            value: getValue(props.data.cellphone),
        },
    ];

    //Retourne la vue
    return (
        <div className={'accountUi'}>
            <div className="accountCard">
                <div className="accountCard__summary">
                    <div className="accountCard__identity">
                        <div className="accountCard__avatar">{getInitials()}</div>
                        <div className="accountCard__identityContent">
                            <Typography variant="h4">
                                {getValue(`${props.data.firstName ?? ''} ${props.data.lastName ?? ''}`.trim())}
                            </Typography>
                        </div>
                    </div>
                    <div className="accountCard__actions">
                        <Typography variant={'button'}>
                            <Button variant={'contained'} onClick={props.handleClickOpen} data-testid={'report-change'}>
                                Signaler un changement
                            </Button>
                        </Typography>
                    </div>
                </div>

                <div className="accountCard__divider" />

                <Grid container spacing={2} className="accountCard__detailsGrid">
                    {details.map(detail => (
                        <Grid item xs={12} md={6} className="accountCard__detailsItem" key={detail.label}>
                            <div className="accountCard__detail">
                                <span className="accountCard__detailIcon">{detail.icon}</span>
                                <div className="accountCard__detailContent">
                                    <Typography variant="body2" className="accountCard__detailLabel">
                                        {detail.label}
                                    </Typography>
                                    <Typography variant="body1" className="accountCard__detailValue">
                                        {detail.value}
                                    </Typography>
                                </div>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </div>
            <ReportChangeDialogForm
                open={props.open}
                userInfos={props.data}
                handleClose={props.handleClose}
                onSuccess={props.handleSuccess}
            />
        </div>
    );
}
